import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { fdate, LegalHtml } from "@/components/legal/LegalTabs";

export function LegalHistory({ docKey, currentVersion, onRestored }) {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);
  const [preview, setPreview] = useState("");

  useEffect(() => { api.get(`/admin/legal/${docKey}/history`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [docKey]);
  useEffect(() => {
    if (!open) { setPreview(""); return; }
    const v = items?.find((i) => i.version === open);
    if (v) api.post("/admin/legal/preview", { content_md: v.content_md }).then((r) => setPreview(r.data.html)).catch(() => setPreview(""));
  }, [open, items]);

  const restore = async (version) => {
    if (!window.confirm(`Recharger la version ${version} dans le brouillon ? Le brouillon actuel sera remplacé.`)) return;
    try { await api.post(`/admin/legal/${docKey}/restore/${version}`); toast.success(`Version ${version} chargée dans le brouillon`); onRestored?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (!items) return <div className="text-sm text-[#868E96]">Chargement…</div>;
  return (
    <div className="grid lg:grid-cols-[320px_1fr] gap-6" data-testid="legal-history">
      <div className="divide-y divide-[#DEE2E6] border border-[#DEE2E6] bg-white">
        {items.map((v) => (
          <div key={v.version} className={`p-3 text-xs ${open === v.version ? "bg-[#F8F9FA]" : ""}`} data-testid={`legal-version-${v.version}`}>
            <div className="flex items-center gap-2">
              <button type="button" onClick={() => setOpen(open === v.version ? null : v.version)} className="font-mono font-bold hover:text-[#002FA7]" data-testid={`legal-version-open-${v.version}`}>v{v.version}</button>
              {v.version === currentVersion && <span className="text-[9px] font-bold uppercase tracking-wider bg-[#059669] text-white px-1.5 py-0.5">En vigueur</span>}
              <span className="flex-1 text-[#868E96]">{fdate(v.published_at)}</span>
              {v.version !== currentVersion && <button type="button" onClick={() => restore(v.version)} data-testid={`legal-version-restore-${v.version}`} className="inline-flex items-center gap-1 font-semibold hover:text-[#002FA7]"><RotateCcw className="h-3 w-3" />Restaurer</button>}
            </div>
            <div className="text-[#495057] mt-1">{v.title} · par {v.published_by_name}{v.change_note ? ` — « ${v.change_note} »` : ""}</div>
          </div>
        ))}
      </div>
      <div className="bg-white border border-[#DEE2E6] p-6 min-h-[200px]" data-testid="legal-history-preview">
        {open ? <LegalHtml html={preview} testid="legal-history-html" /> : <div className="text-xs text-[#868E96]">Cliquez sur une version pour l'afficher.</div>}
      </div>
    </div>
  );
}
